<template>
    <button
        v-tippy="t('editorToggleUnderline')"
        :class="[
            buttonState(
                editor.can().toggleUnderline() && editorSelection.text.length > 0,
                editor.isActive('underline'),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleUnderline() || editorSelection.text.length === 0"
        @click="editor.chain().focus().toggleUnderline().run()"
    >
        <MdiFormatUnderline class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import { MdiFormatUnderline } from 'materialdesignicons-vue3/icons/';

    defineExpose({
        name: 'UnderlineTextButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
        editorSelection: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
    const editorSelection = props.editorSelection;
</script>
